import {
  createListingCategoryGetServerSideProps,
  createListingCategoryPage,
} from '@web/library/listing-category-page';
import { Animal } from 'shared/@generated/models';

const config = {
  animal: Animal.Dog,
  translationKey: 'dogs',
};

export default createListingCategoryPage(config);

export const getServerSideProps = createListingCategoryGetServerSideProps(config);
